/* Street Garms SG-043 — product-card metadata density experiment.
 * Current/no parameter = Size + Condition (preserves the present site).
 * Test URLs:
 *   ?sg_card=control
 *   ?sg_card=size_condition
 *   ?sg_card=size_colour
 *   ?sg_card=auto   (1/3 session-level random assignment)
 *
 * Tracking hooks are dataLayer events only; no third-party network calls are made here.
 */
(function () {
  'use strict';

  var EXPERIMENT = 'SG-043';
  var PARAM = 'sg_card';
  var SESSION_KEY = 'sg043CardVariant';
  var LAST_CLICK_KEY = 'sg043LastProductClick';
  var VALID = ['control', 'size_condition', 'size_colour'];

  function normalise(value) {
    value = String(value || '').toLowerCase().trim().replace(/-/g, '_');
    if (value === 'a' || value === 'control' || value === 'current_original') return 'control';
    if (value === 'b' || value === 'size_condition' || value === 'condition') return 'size_condition';
    if (value === 'c' || value === 'size_colour' || value === 'size_color' || value === 'colour' || value === 'color') return 'size_colour';
    if (value === 'auto' || value === 'random') return 'auto';
    return '';
  }

  function randomVariant() {
    return VALID[Math.floor(Math.random() * VALID.length)];
  }

  function getVariant() {
    var requested = '';
    try { requested = normalise(new URL(window.location.href).searchParams.get(PARAM)); } catch (e) {}

    if (requested === 'auto') {
      try {
        var storedAuto = normalise(window.sessionStorage.getItem(SESSION_KEY));
        if (VALID.indexOf(storedAuto) !== -1) return storedAuto;
        var assigned = randomVariant();
        window.sessionStorage.setItem(SESSION_KEY, assigned);
        return assigned;
      } catch (e) {
        return randomVariant();
      }
    }

    if (VALID.indexOf(requested) !== -1) {
      try { window.sessionStorage.setItem(SESSION_KEY, requested); } catch (e) {}
      return requested;
    }

    // Deliberately preserve today's live/current card when no experiment parameter is supplied.
    return 'size_condition';
  }

  function push(eventName, variant, extra) {
    var payload = {
      event: eventName,
      sg_experiment_id: EXPERIMENT,
      sg_card_variant: variant
    };
    if (extra) {
      Object.keys(extra).forEach(function (key) { payload[key] = extra[key]; });
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function dispatch(eventName, variant, extra) {
    try {
      window.dispatchEvent(new CustomEvent(eventName, {
        detail: Object.assign({ experiment: EXPERIMENT, variant: variant }, extra || {})
      }));
    } catch (e) {}
  }

  function getCardProduct(card) {
    var data = {};
    try { data = JSON.parse(card.getAttribute('data-product-options') || '{}'); } catch (e) {}
    var link = card.querySelector('a[data-pr-href][href]');
    return {
      product_id: data.id || '',
      product_handle: data.handle || '',
      product_url: link ? link.getAttribute('href') : ''
    };
  }

  function bindCardClicks(variant) {
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('.t4s-product a[data-pr-href][href]');
      if (!link) return;
      var card = link.closest('.t4s-product');
      if (!card || !card.querySelector('[data-sg043-card-meta]')) return;

      var product = getCardProduct(card);
      push('sg043_product_card_click', variant, product);
      dispatch('sg:product-card-click', variant, product);

      try {
        window.sessionStorage.setItem(LAST_CLICK_KEY, JSON.stringify({
          variant: variant,
          product_id: product.product_id,
          product_handle: product.product_handle,
          product_url: product.product_url,
          timestamp: Date.now()
        }));
      } catch (e) {}
    }, true);
  }

  function readLastClick() {
    try {
      var raw = window.sessionStorage.getItem(LAST_CLICK_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || VALID.indexOf(normalise(data.variant)) === -1) return null;
      if (!data.timestamp || Date.now() - data.timestamp > 30 * 60 * 1000) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function trackPdpProgression() {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    var click = readLastClick();
    if (!click) return;

    var variant = normalise(click.variant);
    var path = window.location.pathname || '';
    if (click.product_handle && path.indexOf('/products/' + click.product_handle) === -1) return;

    push('sg043_pdp_view', variant, {
      product_id: click.product_id || '',
      product_handle: click.product_handle || ''
    });
    dispatch('sg:pdp-view', variant, click);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      push('sg043_pdp_add_to_cart', variant, {
        product_id: click.product_id || '',
        product_handle: click.product_handle || ''
      });
      dispatch('sg:pdp-add-to-cart', variant, click);
    }, true);
  }

  function apply() {
    var variant = getVariant();
    document.documentElement.setAttribute('data-sg-card-variant', variant);
    document.documentElement.setAttribute('data-sg-card-experiment', EXPERIMENT);

    var cards = document.querySelectorAll('.t4s-product [data-sg043-card-meta]');
    if (cards.length) {
      push('sg043_card_exposure', variant, { sg_card_count: cards.length });
      dispatch('sg:card-exposure', variant, { cardCount: cards.length });
      bindCardClicks(variant);
    }

    trackPdpProgression();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else {
    apply();
  }
})();
